import Form from "./view/Form";
import Navbar from "./common/Navbar";
import EliteVacancesFooter from "./common/EliteVacancesFooter";
import { ReactComponent as WhatsappSVG } from "../src/assets/whatsapp.svg";

function App() {
  return (
    <>
      <Navbar />
      <Form />
      <a
        href="https://api.whatsapp.com/send?phone=5717945996&text=Hola.%0ARequiero%20de%20su%20ayuda%20para%20el%20debito%20autom%C3%A1tico"
        className="whatsapp-float"
        target="_blank"
        rel="noreferrer"
      >
        <WhatsappSVG height={35} />
      </a>
      <EliteVacancesFooter />
    </>
  );
}

export default App;
